import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Mediator } from '@spotahome/soyuz-mediator';

import { TOKEN_EXPIRED } from '../utils/channels';

import LoginModal from './login/LoginModal';

import withModalHandle from './withModalHandle';

class SessionExpiredModal extends Component {
  static propTypes = {
    handleModalOpen: PropTypes.func.isRequired,
    handleModalClose: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired
  };

  componentDidMount = () => {
    Mediator.subscribe(TOKEN_EXPIRED, this.props.handleModalOpen);
  };

  componentWillUnmount = () => {
    Mediator.unsubscribe(TOKEN_EXPIRED, this.props.handleModalOpen);
  };

  render() {
    return (
      <LoginModal
        onClose={this.props.handleModalClose}
        isOpen={this.props.isModalOpen}
      />
    );
  }
}

export default withModalHandle()(SessionExpiredModal);
